import { render } from "./FavoriteRoutes.vue?vue&type=template&id=b3179cc2&scoped=true"
import script from "./FavoriteRoutes.vue?vue&type=script&lang=js"
export * from "./FavoriteRoutes.vue?vue&type=script&lang=js"

import "./FavoriteRoutes.vue?vue&type=style&index=0&id=b3179cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3179cc2"]])

export default __exports__